import { useThemeContext } from 'ssap-ui-kit';
import classNames from 'classnames';
import React, { createContext, ReactNode, useContext, useState } from 'react';
import { useIntl } from 'react-intl';
import background from '../../../images/background.svg';
import backgroundDark from '../../../images/backgroundDark.png';
import { BottomDisclaimer, TopDisclaimer } from '../../../ui-config';
import Footer from '../../Footer';
import Menu from '../../menu/Menu';
import messages from './messages';
import staticStyles from './style';

export interface ScreensWrapperProps {
  children: ReactNode;
}

export const TitleContext = createContext({
  title: '',
  setTitle: (title: string) => {},
});

export function useHeaderTitle() {
  const { title, setTitle } = useContext(TitleContext);
  return { title, setTitle };
}

export const TopPanelSmallContext = createContext({
  isTopPanelSmall: false,
  setTopPanelSmall: (isSmallTopLine: boolean) => {},
});

export function useWithDesktopTitle() {
  const { isTopPanelSmall, setTopPanelSmall } = useContext(TopPanelSmallContext);
  return { isTopPanelSmall, setTopPanelSmall };
}

export default function ScreensWrapper({ children }: ScreensWrapperProps) {
  const intl = useIntl();
  const { currentTheme, isCurrentThemeDark } = useThemeContext();

  const [title, setTitle] = useState(intl.formatMessage(messages.pageTitle));
  const [isTopPanelSmall, setTopPanelSmall] = useState(
    localStorage.getItem('isTopPanelSmall') === 'true' || false
  );

  return (
    <div
      className={classNames('ScreensWrapper _pst-rlt', {
        ScreensWrapper__topPanelSmall: isTopPanelSmall,
      })}
    >
      <BottomDisclaimer />

      <TopDisclaimer />
      <Menu title={title} />

      <main className="ScreensWrapper__content" id="ScreensWrapper__content-wrapper">
        <div className="ScreensWrapper__top-contentWrapper" />

        <TitleContext.Provider value={{ title, setTitle }}>
          <TopPanelSmallContext.Provider value={{ isTopPanelSmall, setTopPanelSmall }}>
            {children}
          </TopPanelSmallContext.Provider>
        </TitleContext.Provider>
      </main>

      <Footer inside={true} />

      <img
        className="ScreensWrapper__background"
        src={isCurrentThemeDark ? backgroundDark : background}
        alt=""
      />

      <img
        alt="top background"
        className="top-background _pst-asl _t-0px _l-0px _r-0px _w-100pct-sm _mnw-100pct _zid-2"
        src="/images/menu/top-section-mini-background.png"
      />

      <style jsx={true} global={true}>
        {staticStyles}
      </style>
      <style jsx={true} global={true}>{`
        @import 'src/_mixins/screen-size';

        .ScreensWrapper {
          background: ${currentTheme.mainBg.hex};

          &__top-contentWrapper {
            // background: ${currentTheme.headerBg.hex};
            // &:after {
            //   background: ${currentTheme.headerBg.hex};
            // }
          }

          .top-background {
            min-height: 90px;
            max-height: 100px;
            @include respond-to(sm) {
              max-height: 64px;
            }
          }
        }
      `}</style>
    </div>
  );
}
